"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.isEventPassed = exports.isSameYear = exports.isSameMonth = exports.isSameDay = exports.isSameDate = exports.getFriendlyUTCDate = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var utc_1 = __importDefault(require("dayjs/plugin/utc")); // import plugin
dayjs_1["default"].extend(utc_1["default"]);
function getFriendlyUTCDate(date, template) {
    return dayjs_1["default"].utc(date).format(template);
}
exports.getFriendlyUTCDate = getFriendlyUTCDate;
var isSameDate = function (arg, arg1) {
    return (0, dayjs_1["default"])(arg).isSame((0, dayjs_1["default"])(arg1));
};
exports.isSameDate = isSameDate;
var isSameDay = function (arg, arg1) {
    return (0, dayjs_1["default"])(arg).isSame((0, dayjs_1["default"])(arg1), 'day');
};
exports.isSameDay = isSameDay;
var isSameMonth = function (arg, arg1) {
    return (0, dayjs_1["default"])(arg).isSame((0, dayjs_1["default"])(arg1), 'month');
};
exports.isSameMonth = isSameMonth;
var isSameYear = function (arg, arg1) {
    return (0, dayjs_1["default"])(arg).isSame((0, dayjs_1["default"])(arg1), 'year');
};
exports.isSameYear = isSameYear;
var isEventPassed = function (arg, unit) {
    return (0, dayjs_1["default"])().isAfter((0, dayjs_1["default"])(arg), unit !== null && unit !== void 0 ? unit : 'day');
};
exports.isEventPassed = isEventPassed;
